import { render, staticRenderFns } from "./Stockchart.vue?vue&type=template&id=3aa36ad7&"
import script from "./Stockchart.vue?vue&type=script&lang=js&"
export * from "./Stockchart.vue?vue&type=script&lang=js&"
import style0 from "./Stockchart.vue?vue&type=style&index=0&id=3aa36ad7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports